import { render, staticRenderFns } from "./cnki.vue?vue&type=template&id=c0f7cf50&scoped=true&"
import script from "./cnki.vue?vue&type=script&lang=js&"
export * from "./cnki.vue?vue&type=script&lang=js&"
import style0 from "./cnki.vue?vue&type=style&index=0&id=c0f7cf50&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f7cf50",
  null
  
)

export default component.exports